module.exports = __webpack_public_path__ + "img/fig33.f8f97541.jpg";